import { useOraclePrices, UserExternalRewardsPnlInfoExpanded } from "@bridgesplit/abf-react";
import { Row, Column, Text } from "@bridgesplit/ui";
import { formatTokenAmount, formatUsd } from "@bridgesplit/utils";
import { TokenImage } from "app/components/common";

import { VaultExternalRewardsClaimCta } from "./VaultExternalRewardsClaimCta";
import { useVaultContext } from "../VaultContext";

export function VaultExternalRewards() {
    const { activeRewards } = useVaultContext();

    if (!activeRewards) return null;

    return (
        <>
            {activeRewards.map((reward, i) => (
                <ExternalRewardsClaimDetails key={`${reward.rewardMint}-${i}`} reward={reward} />
            ))}
        </>
    );
}

function ExternalRewardsClaimDetails({ reward }: { reward: UserExternalRewardsPnlInfoExpanded }) {
    const { vaultExpanded } = useVaultContext();
    const { getOracle } = useOraclePrices([reward.rewardMint]);
    const usdPrice = getOracle(reward.rewardMint)?.usdPrice;
    const tokenPrice = reward.pendingRewards * (usdPrice ?? 0);

    return (
        <Row spaceBetween>
            <Row spacing={1}>
                <TokenImage metadata={reward.rewardMetadata} />
                <Column>
                    <Text>{formatTokenAmount(reward.pendingRewards, reward.rewardMetadata)}</Text>
                    <Text color="caption" variant="body2">
                        {formatUsd(tokenPrice)}
                    </Text>
                </Column>
            </Row>
            <VaultExternalRewardsClaimCta shortText claimMints={[reward.rewardMint]} vaultExpanded={vaultExpanded} />
        </Row>
    );
}
